
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/secret-soundtrack-formula-for-gyms-and-cafes",
      function () {
        return require("private-next-pages/articles/secret-soundtrack-formula-for-gyms-and-cafes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/secret-soundtrack-formula-for-gyms-and-cafes"])
      });
    }
  